<template>
  <div class="CorpInfo">
    <!-- 当前位置 -->
    <div class="container">
      <div class="content" >
        <div class="sys">
        <h1>西安市高陵区源盛水务有限公司</h1>（原西安市高陵区自来水厂，2019年12月企业改制国有独资公司，更名为“西安市高陵区源盛水务有限公司”）始建于1969年。公司现有在职员工138人，根据业务需求，公司设立五科一室，分别为：财务科（包括收费服务大厅）、生产科、供水运行科（供水厂站运行）、抄表收费科、劳务科和办公室。
<p>公司现有城区配水厂、第二自来水厂、张卜农村集中供水站、皇渠湾农村集中供水站等4处供水厂站，总供水能力3.2万m³/日。</p>
<p>城区配水厂及黑河水源输水工程由区政府投资建设，2008年9月建成通水，供水能力1. 8万m³／日，主要服务于城区居民的生产生活用水，延伸覆盖周边两个街道五个行政村，用水人口约8万余人。</p>
<p>第二自来水厂是我公司2016年4月接收的原长庆泾渭苑水厂，水厂设计供水能力10000吨／日，目前管网覆盖区域内有23家用水单位，用水人口约5万人。</p>
<p>张卜农村集中供水站2010年6月建成投入使用，供水能力1420m³／日，供水范围涉及2个街道11行政个村，约7206户村民用水。</p>
<p>黄渠湾供水站始建于2011年，2012年10月建成投入使用，供水能力3000m³／日，供水范围涉及3个街道11个行政村，约5190户村民用水。</p>
        </div>
        <div class="showimg" >
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_1.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px; ">公司场景1</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_2.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景2</span>
          </el-col>
        </el-row>
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_3.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px; ">公司场景3</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_4.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景4</span>
          </el-col>
        </el-row>
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_5.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px; ">公司场景5</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_6.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景6</span>
          </el-col>
        </el-row>
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_7.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px; ">公司场景7</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_8.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景8</span>
          </el-col>
        </el-row>
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_9.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px; ">公司场景9</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_10.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景10</span>
          </el-col>
        </el-row>
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_11.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px; ">公司场景11</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_12.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景12</span>
          </el-col>
        </el-row>
        <el-row :span="24"  >
          <el-col :span="12" type="flex" justify="center" >
            <el-image
              :src="require('@/assets/glimg/gltp_13.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景13</span>
          </el-col>
          <el-col :span="12" >
            <el-image
              :src="require('@/assets/glimg/gltp_14.png')"
              fit="fit"></el-image>
              <span style="font-weight:bold;font-size: 24px;">公司场景14</span>
          </el-col>
        </el-row>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created(){
  },
  methods:{
getSys(){
  this.Api.getSys().then((res)=>{
    if(res.code == 0){
      console.log(res);
      this.list=res.data
    }
  })
}
  },
  data(){
    return{
      // 系统列表
list:[]
    }
  },

};
</script>



<style lang="less" scoped>
p {
  color: #666666;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 25px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 6px;
}
h4 {
  color: #333333;
  font-size: 18px;
}
.CorpInfo {
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}

.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}

.showimg {
  .el-image {
    width: 100%;
    height: 260px;
  }
}




</style>